<template>
    <div>
        <h1>404 Not Found</h1>
        <p>The page you are looking for does not exist.</p>
    </div>
</template>

<script setup lang="ts">
import router from '@/router/index';
import { onMounted } from 'vue';

const token = localStorage.getItem('token');

onMounted(() => {
    checkRoutes();
});

const checkRoutes = () => {
    if (!token) {
        router.push('/login');
        return;
    }
};
</script>
